import { render, staticRenderFns } from "./IncomingPayment.vue?vue&type=template&id=23066e5c"
import script from "./IncomingPayment.vue?vue&type=script&lang=js"
export * from "./IncomingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports